// utils/auth.js
import {jwtDecode} from "jwt-decode";

export const checkAuth = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000; // seconds
    if (decoded.exp < now) {
      // Token expired, clean up
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("role");
      return false;
    }
    return true;
  } catch (err) {
    localStorage.clear();
    return false;
  }
};
